import { getUnitColor } from "../../../utilities/UnitsAndKeys/getUnitColor";
// import useDataResource from "../../../hooks/useDataResource/useDataResource";
import { subMonths, startOfMonth, endOfMonth } from "date-fns";
import LoadingDots from "../../../LoadingDots/LoadingDots";
import React, { useState, useEffect } from "react";
import { HeatmapHeader } from "./HeatmapHeader";
import { getMinMax } from "./Heatmap.utils";
import AmChartHeatmap from "./HeatmapChart";
import { Box } from "@material-ui/core";

export const defaultSettings = {
  startDate: subMonths(new Date(), 7),
  endDate: new Date(),
  availableDataKeys: [
    "solarGenerated",
    "gridConsumed",
    "solarConsumed",
    "solarFeedIn",
    "netConsumed",
  ],
};

export const Heatmap = ({
  resourceId,
  resourceType,
  hideTitle,
  hideDropdown,
  hideGradient,
  height,
  handleHeatmapClick,
  api,
}) => {
  const { startDate, endDate, availableDataKeys } = defaultSettings;
  // const { accessToken } = typeof user !== "undefined" ? user : {};
  // const [DataApi] = useDataResource("data", accessToken);
  const [data, setData] = useState();
  // const [dataKey, setDataKey] = useState(availableDataKeys[0]);
  const [dataKey, setDataKey] = useState();
  const minColor = "#FFF";
  const maxColor = getUnitColor(dataKey);

  // Fetching
  useEffect(() => {
    (async () => {
      try {
        const data = await api.call('data', 'getEnergyFeed', [
          resourceType,
          resourceId,
          startOfMonth(startDate).toISOString(),
          endOfMonth(endDate).toISOString(),
          "day"
        ]);
        // get first datakey
        // get second datakey if no data on first
        // get first datakey if no data on either
        // i dont like it either
        let dataKey = availableDataKeys[0];
        if (!data.totals[availableDataKeys[0]]) {
          dataKey = availableDataKeys[1];
        }
        if (!data.totals[availableDataKeys[1]]) {
          dataKey = availableDataKeys[0];
        }
        setDataKey(dataKey);
        setData(data);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  return data && dataKey ? (
    <Box marginX={3}>
      <HeatmapHeader
        hideTitle
        hideGradient
        dataKey={dataKey}
        setDataKey={setDataKey}
        startDate={startOfMonth(startDate)}
        endDate={endOfMonth(endDate)}
        minMax={getMinMax(data, dataKey)}
        colors={[minColor, maxColor]}
      />
      <AmChartHeatmap
        data={data}
        dataKey={dataKey}
        height={height}
        graphId={0}
        handleHeatmapClick={handleHeatmapClick}
      />
    </Box>
  ) : (
    <div
      style={{ height: "350px" }}
      className="aspect-ratio-content text-center d-flex flex-column justify-content-center align-items-center"
    >
      <LoadingDots spinnerClass="bg-primary" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/Heatmap/Heatmap.js